(() => {
  const root = document.querySelector('[data-tm-private-wheel-v2]');
  if (!root || root.dataset.bound === 'true') return;
  root.dataset.bound = 'true';
  const one = name => root.querySelector('[data-tm-v2-' + name + ']');
  const overlay = one('overlay');
  const dialog = overlay.querySelector('[role="dialog"]');
  const disc = one('disc');
  const button = one('spin');
  const addProductButton = one('add-product');
  const status = one('status');
  const title = one('title');
  const description = one('description');
  const resultClose = one('result').querySelector('[data-tm-v2-close]');
  const initialTitle = title.innerHTML;
  const initialDescription = description.textContent;
  const initialEyebrow = one('eyebrow').textContent;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const now = () => window.TMPrivateOffers?.now?.() || Date.now();
  const pause = ms => new Promise(resolve => window.setTimeout(resolve, ms));
  let phase = 'idle';
  let offer = null;
  let outcome = null;
  let busy = false;
  let revealing = false;
  let applying = false;
  let applyRequest = null;
  let applyFailed = false;
  let previousFocus = null;
  let previousOverflow = '';
  let angle = 0;
  let animationFrame = 0;
  let animationTimeout = 0;
  let finishAnimation = null;
  let slowTimer = 0;
  let expired = false;
  let productAdded = false;
  let triggerInFlight = false;
  let triggerShownInMemory = false;
  let activeMilliseconds = 0;
  let interestSeen = false;
  let maximumDepth = 0;
  let lastInteractionAt = window.performance.now();
  let previousScrollY = window.scrollY;
  let upwardScroll = 0;
  let reviewsSeen = false;
  let triggerRetryAt = 0;
  let triggerTimer = 0;
  let cartRecoveryReadyAt = 0;
  let cartWasBlocked = false;
  let hasRevealed = false;
  const legacyTriggerStorageKey = 'tmWheelHesitationShownV2';
  const frequencyStorageKey = 'tmWheelAutoFrequencyV3';
  const autoWindowMilliseconds = 24 * 60 * 60 * 1000;
  const returnVisitDelayMilliseconds = 30 * 60 * 1000;
  const cartRecoveryDelayMilliseconds = 6000;
  const triggerTickMilliseconds = 250;
  const cartBlocked = () => /(?:^|\/)(?:checkout|checkouts)(?:\/|$)/.test(window.location.pathname)
    || Boolean(document.querySelector('cart-drawer.active, #cart-notification.active, .tm-cart-notification-open'));
  const onCartPage = () => /(?:^|\/)cart(?:\/|$)/.test(window.location.pathname);
  const emptyFrequency = () => ({ shownAt: [], lastDismissedAt: 0, lastDismissReason: null });
  const readFrequency = () => {
    const timestamp = Date.now();
    try {
      const parsed = JSON.parse(window.localStorage.getItem(frequencyStorageKey) || "null");
      const shownAt = Array.isArray(parsed?.shownAt)
        ? parsed.shownAt.map(Number).filter(value => Number.isFinite(value) && timestamp - value < autoWindowMilliseconds)
        : [];
      const lastDismissedAt = Number(parsed?.lastDismissedAt) || 0;
      return { shownAt, lastDismissedAt: timestamp - lastDismissedAt < autoWindowMilliseconds ? lastDismissedAt : 0, lastDismissReason: parsed?.lastDismissReason || null };
    } catch { return emptyFrequency(); }
  };
  const writeFrequency = value => {
    try { window.localStorage.setItem(frequencyStorageKey, JSON.stringify(value)); } catch {}
    return value;
  };
  const migrateLegacyFrequency = () => {
    try {
      if (window.sessionStorage.getItem(legacyTriggerStorageKey) !== '1') return;
      const frequency = readFrequency();
      if (!frequency.shownAt.length) writeFrequency({ ...frequency, shownAt: [Date.now()] });
      window.sessionStorage.removeItem(legacyTriggerStorageKey);
    } catch {}
  };
  const track = (eventName, detail = {}) => {
    const payload = { source: "tm-private-wheel-v2", productId: root.dataset.tmProductId || null, ...detail };
    try { window.Shopify?.analytics?.publish?.(eventName, payload); } catch {}
    try { window.dataLayer?.push?.({ event: eventName, ...payload }); } catch {}
    document.dispatchEvent(new CustomEvent('tm:wheel-analytics', { detail: { eventName, ...payload } }));
  };
  const cartReturnEligible = () => window.TMWheelVisit?.cartReturnEligible === true;
  const canShowAutomatically = reason => window.TMWheelJourney?.canAuto() === true;
  const rememberTrigger = (reason, cartItemCount) => {
    triggerShownInMemory = true;
    window.TMWheelJourney?.markAuto(reason);
    const frequency = readFrequency();
    frequency.shownAt.push(Date.now());
    writeFrequency(frequency);
    if (reason === 'cart-return-no-checkout') window.TMWheelVisit?.markRecoveryShown?.();
    track("tm_wheel_impression", { triggerReason: reason, impressionCount24h: frequency.shownAt.length, activeMilliseconds, cartItemCount });
  };
  const rememberDismiss = reason => {
    if (!['maybe-later', 'close-button', 'overlay', 'escape'].includes(reason)) return;
    window.TMWheelJourney?.dismiss();
    const frequency = readFrequency();
    frequency.lastDismissedAt = Date.now();
    frequency.lastDismissReason = reason;
    writeFrequency(frequency);
    track("tm_wheel_dismiss", { dismissReason: reason, impressionCount24h: frequency.shownAt.length, activeMilliseconds });
  };
  const queueCartRecovery = () => {
    if (!cartReturnEligible() || readFrequency().shownAt.length >= 2) return;
    cartRecoveryReadyAt = window.performance.now() + cartRecoveryDelayMilliseconds;
  };
  migrateLegacyFrequency();
  const otherDialogOpen = () => [...document.querySelectorAll('[role="dialog"], dialog[open]')]
    .some(element => {
      if (element === dialog || element.closest('[hidden], details:not([open])')) return false;
      const style = getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      return style.visibility !== 'hidden' && Number(style.opacity) > 0 && rect.width > 4 && rect.height > 4
        && rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
    });
  const cartJsonUrl = () => (root.dataset.tmCartUrl || '/cart').replace(/\/$/, '') + '.js';
  const getCart = async () => {
    const response = await fetch(cartJsonUrl(), { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('cart_unavailable');
    return response.json();
  };
  const nativePrizes = Object.freeze({
    TMPRIVATE3: { kind: 'discount', title: '17% off', percent: 17, angle: 275.4 },
    TMPRIVATE5: { kind: 'discount', title: '18% off', percent: 18, angle: 135 },
    TMPLUS5: { kind: 'discount', title: '20% off', percent: 20, angle: 45 },
    TMMYSTERYVIBE: { kind: 'gift', title: 'Mystery gift', percent: 0, angle: 185.4 }
  });
  const nativeOffer = value => {
    if (value?.nativeShopify !== true || value.serverEnforced !== false) return false;
    const prize = Object.prototype.hasOwnProperty.call(nativePrizes, value.code) ? nativePrizes[value.code] : null;
    if (!prize || value.kind !== prize.kind || value.title !== prize.title || value.percent !== prize.percent || value.angle !== prize.angle) return false;
    if (value.browserTimed === true) return Number.isFinite(value.awardedAt) && value.awardedAt > 0
      && Number.isFinite(value.expiresAt) && value.expiresAt === value.awardedAt + 900000
      && (prize.kind === 'gift' ? value.permanentGift === false : value.permanentGift !== true);
    return value.expiresAt === null && (prize.kind === 'gift' ? value.permanentGift === true : value.permanentGift !== true);
  };
  const timedOffer = value => Boolean(value && value.permanentGift !== true && Number.isFinite(Number(value.expiresAt)) && Number(value.expiresAt) > 0
    && ((nativeOffer(value) && value.browserTimed === true) || (value.nativeShopify !== true && value.serverEnforced === true)));
  const offerExpired = value => timedOffer(value) && Number(value.expiresAt) <= now();
  const sessionOffer = session => {
    const value = session?.offer;
    if (session?.state !== 'claimed' || !value?.code || !value?.title || !Number.isFinite(Number(value.angle))) return null;
    if (value.nativeShopify === true) return nativeOffer(value) ? value : null;
    if (value.kind !== 'discount' && value.kind !== 'gift') return null;
    if (value.serverEnforced !== true && !(value.kind === 'gift' && value.permanentGift === true)) return null;
    if (value.kind === 'discount' && (!(Number(value.expiresAt) > 0) || !Number.isFinite(Number(value.expiresAt)) || value.permanentGift === true)) return null;
    return value;
  };
  const productForms = () => {
    const forms = [...document.querySelectorAll('form[action*="/cart/add"]')];
    const matching = forms.filter(form => form.querySelector('[name="product-id"][value="' + root.dataset.tmProductId + '"]'));
    return matching.length ? matching : forms;
  };
  const selectedVariantId = () => {
    const forms = productForms();
    const form = forms.find(candidate => candidate.getClientRects().length > 0) || forms[0];
    const field = form?.querySelector('select[name="id"]:not(:disabled), input[name="id"]:not(:disabled)');
    const value = field?.value || root.dataset.tmDefaultVariantId;
    return /^\d+$/.test(value || '') ? Number(value) : null;
  };
  const stopAnimation = () => {
    window.cancelAnimationFrame(animationFrame);
    window.clearTimeout(animationTimeout);
    animationFrame = 0;
    animationTimeout = 0;
    if (finishAnimation) { const resolve = finishAnimation; finishAnimation = null; resolve(); }
  };
  const paintAngle = value => { angle = value; disc.style.transform = 'rotate(' + value + 'deg)'; disc.style.setProperty('--tmw-label-angle', (-value) + 'deg'); };
  const spinAnimation = () => {
    stopAnimation();
    if (reducedMotion || overlay.hidden) return;
    let previous = window.performance.now();
    const frame = time => {
      paintAngle(angle + Math.min(64, Math.max(0, time - previous)) * .48);
      previous = time;
      animationFrame = window.requestAnimationFrame(frame);
    };
    animationFrame = window.requestAnimationFrame(frame);
  };
  const landAnimation = target => {
    stopAnimation();
    const normalized = ((Number(target) % 360) + 360) % 360;
    if (reducedMotion || overlay.hidden || cartBlocked()) { paintAngle(normalized); return Promise.resolve(); }
    const from = angle;
    const to = from + 720 + ((normalized - (from % 360) + 360) % 360);
    const started = window.performance.now();
    const duration = 2400;
    return new Promise(resolve => {
      finishAnimation = resolve;
      const finish = () => { paintAngle(to); stopAnimation(); };
      const frame = time => {
        const progress = Math.min(1, Math.max(0, time - started) / duration);
        paintAngle(from + (to - from) * (1 - Math.pow(1 - progress, 4)));
        if (progress === 1) finish();
        else animationFrame = window.requestAnimationFrame(frame);
      };
      animationTimeout = window.setTimeout(finish, duration + 180);
      animationFrame = window.requestAnimationFrame(frame);
    });
  };
  const setPhase = value => {
    phase = value;
    root.dataset.phase = value;
    one('intro').hidden = value === 'result' || value === 'expired';
    one('result').hidden = value !== 'result' && value !== 'expired';
    button.disabled = busy || value === 'expired';
    button.textContent = busy ? 'Preparing your reward…' : value === 'error' ? 'Try again' : window.TMPrivateOffers?.getSession?.()?.renewableOffer ? 'Reactivate my reward' : 'Spin now';
    dialog.setAttribute('aria-busy', busy ? 'true' : 'false');
  };
  const clearSummary = () => { one('summary').hidden = true; one('timer').hidden = true; };
  const renderExpired = () => {
    expired = true;
    status.textContent = '';
    one('eyebrow').textContent = 'Tu Mando';
    const endedOffer = offer || window.TMPrivateOffers?.getSession?.()?.offer;
    title.textContent = 'Your reward is saved for your next visit';
    description.textContent = 'Your bag and current offers are still ready.';
    one('checkout').hidden = true;
    clearSummary();
    if (addProductButton) {
      addProductButton.hidden = true;
      addProductButton.disabled = true;
    }
    one('apply').hidden = true;
    one('apply').disabled = true;
    resultClose.classList.add('tm-private-wheel__primary');
    resultClose.classList.remove('tm-private-wheel__secondary');
    setPhase('expired');
  };
  const tick = () => {
    if (!timedOffer(offer)) return;
    const seconds = Math.max(0, Math.ceil((Number(offer.expiresAt) - now()) / 1000));
    if (seconds === 0) { if (!expired) renderExpired(); return; }
    one('clock').textContent = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
  };
  const renderResult = () => {
    if (!offer) return;
    if (offerExpired(offer) || outcome?.reason === 'expired') { renderExpired(); return; }
    one('eyebrow').textContent = outcome?.applied ? 'Applied to your bag' : applying ? 'Applying your reward' : 'Your reward';
    title.textContent = offer.kind === 'gift' ? 'You won a mystery gift' : 'You won ' + offer.title;
    description.textContent = applying ? 'Adding your reward to your bag.' : outcome?.applied
      ? (offer.kind === 'gift' ? 'Your free gift is in your bag.' : 'Your discount is in your bag.')
      : applyFailed ? 'Your reward is saved. Try again to apply it.'
        : outcome?.reason === 'current' ? 'Your current discount gives you the better price, so it stays in your bag.'
        : offer.kind === 'gift' ? 'Add this item to your bag to claim your free gift.' : 'Add this item to your bag to use your discount.';
    clearSummary();
    if (outcome?.applied && Number(outcome.cart?.item_count) > 0 && Number.isFinite(outcome.cart.total_price) && outcome.cart.currency) {
      try {
        one('subtotal').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: outcome.cart.currency }).format(outcome.cart.total_price / 100);
        one('summary').hidden = false;
      } catch {}
    }
    one('checkout').hidden = applying || applyFailed || Number(outcome?.cart?.item_count || 0) < 1;
    one('checkout').textContent = outcome?.applied
      ? offer.kind === 'gift' ? 'Checkout with my free gift' : 'Checkout with ' + offer.title
      : 'Continue to checkout';
    const needsProduct = Boolean(addProductButton) && !applying && !productAdded && (outcome?.reason === 'empty' || outcome?.reason === 'empty-gift');
    one('timer').hidden = !timedOffer(offer);
    if (addProductButton) {
      addProductButton.hidden = !needsProduct;
      addProductButton.disabled = applying;
    }
    one('cart').hidden = needsProduct;
    one('apply').hidden = !applyFailed || applying;
    one('apply').disabled = applying;
    one('apply').textContent = 'Try applying again';
    resultClose.classList.remove('tm-private-wheel__primary');
    resultClose.classList.add('tm-private-wheel__secondary');
    setPhase('result');
    tick();
  };
  const close = (restoreFocus = true, dismissReason = 'programmatic') => {
    if (overlay.hidden) return;
    if (!hasRevealed && (phase === 'idle' || phase === 'error')) rememberDismiss(dismissReason);
    overlay.hidden = true;
    document.body.style.overflow = previousOverflow;
    stopAnimation();
    if (restoreFocus && !cartBlocked() && previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
  };
  const open = () => {
    if (cartBlocked() || !overlay.hidden) return false;
    const current = window.TMPrivateOffers?.getSession?.();
    if (current?.state === 'available') {
      expired = false; offer = null; outcome = null; productAdded = false; hasRevealed = false;
      title.textContent = current.renewableOffer ? 'Welcome back. Your reward is ready.' : initialTitle.replace(/<[^>]*>/g, '');
      description.textContent = current.renewableOffer ? 'Reactivate your ' + (current.renewableOffer.kind === 'gift' ? 'free mystery gift' : current.renewableOffer.title) + ' for this visit.' : initialDescription;
      one('eyebrow').textContent = current.renewableOffer ? 'Your saved reward' : initialEyebrow;
      setPhase('idle');
    }
    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    overlay.hidden = false;
    if (expired || window.TMPrivateOffers?.getSession?.()?.state === 'expired') renderExpired();
    else if (revealing) { setPhase('spinning'); spinAnimation(); }
    else if (offer) { renderResult(); if (!offerExpired(offer)) void autoApply(offer); }
    else {
      const cached = sessionOffer(window.TMPrivateOffers?.getSession?.());
      if (cached) { offer = cached; paintAngle(Number(offer.angle)); renderResult(); if (!offerExpired(offer)) void autoApply(offer); }
    }
    dialog.focus({ preventScroll: true });
    return true;
  };
  const services = async () => {
    for (let index = 0; index < 40; index += 1) {
      if (window.TMPrivateOffers?.ensureSession && window.TMWheelCart?.applyOffer) return;
      await pause(100);
    }
    throw new Error('service_not_ready');
  };
  const autoApply = awarded => {
    if (applyRequest) return applyRequest;
    if (!awarded || offerExpired(awarded)) { renderExpired(); return Promise.resolve(null); }
    applying = true;
    applyFailed = false;
    busy = true;
    status.textContent = 'Applying your reward…';
    if (!revealing) renderResult();
    applyRequest = (async () => {
      try {
        await services();
        if (offerExpired(awarded)) { renderExpired(); return null; }
        window.TMWheelCart.rememberOffer(awarded);
        const value = await window.TMWheelCart.applyOffer(awarded);
        if (!value || !value.cart || !['applied', 'empty', 'empty-gift', 'current', 'expired'].includes(value.reason)) throw new Error('invalid_cart_outcome');
        outcome = value;
        window.TMWheelJourney?.track('tm_wheel_apply_result', { result: value.reason, applied: value.applied, rewardKind: awarded.kind, rewardPercent: awarded.percent });
        if (value.changed) window.TMWheelCart.notifyCart(value.cart);
        status.textContent = '';
        return value;
      } catch {
        outcome = null;
        applyFailed = true;
        status.textContent = '';
        return null;
      } finally {
        applying = false;
        busy = revealing;
        applyRequest = null;
        if (!revealing) renderResult();
      }
    })();
    return applyRequest;
  };
  const addSelectedProduct = async () => {
    if (busy || !offer || offerExpired(offer) || cartBlocked()) return;
    const variantId = selectedVariantId();
    if (!variantId) {
      status.textContent = 'Please choose an available option.';
      return;
    }
    applying = true;
    busy = true;
    applyFailed = false;
    status.textContent = '';
    renderResult();
    let added = false;
    try {
      await services();
      const addUrl = (root.dataset.tmCartAddUrl || '/cart/add').replace(/\/$/, '') + '.js';
      const formData = new FormData();
      formData.set('id', String(variantId));
      formData.set('quantity', '1');
      let giftRequest = null;
      try {
        giftRequest = await window.TuMandoGiftAutoAdd?.buildAddRequest?.(formData, [], window.location.pathname, outcome?.cart);
      } catch {}
      const response = await fetch(giftRequest?.url || addUrl, giftRequest?.options || {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!response.ok) throw new Error('product_unavailable');
      added = true;
      productAdded = true;
      window.TuMandoGiftAutoAdd?.afterAdd?.({ variantId, giftIncluded: giftRequest?.giftIncluded === true });
      if (giftRequest?.giftIncluded !== true) await window.TuMandoGiftAutoAdd?.ensure?.({ refreshPopup: false });
      const value = await window.TMWheelCart.applyOffer(offer, { fresh: true });
      if (!value || !value.cart || !['applied', 'current', 'expired'].includes(value.reason)) throw new Error('offer_apply_failed');
      outcome = value;
      if (value.changed || Number(value.cart.item_count) > 0) window.TMWheelCart.notifyCart(value.cart);
    } catch {
      if (added) {
        productAdded = true;
        applyFailed = true;
        try {
          const cart = await getCart();
          outcome = { reason: 'current', applied: false, cart };
          window.TMWheelCart.notifyCart(cart);
        } catch {}
      } else {
        status.textContent = 'Please choose an available option and try again.';
      }
    } finally {
      applying = false;
      busy = false;
      renderResult();
    }
  };
  const reveal = async () => {
    if (busy || cartBlocked() || overlay.hidden || expired) return;
    if (!hasRevealed) { hasRevealed = true; window.TMWheelJourney?.markEngaged(); track("tm_wheel_reveal", { triggerReason: root.dataset.triggerReason || "manual", activeMilliseconds }); }
    const retry = phase === 'error';
    const reactivating = Boolean(window.TMPrivateOffers?.getSession?.()?.renewableOffer);
    revealing = true;
    busy = true;
    status.textContent = '';
    title.innerHTML = initialTitle;
    description.textContent = initialDescription;
    one('eyebrow').textContent = initialEyebrow;
    setPhase('spinning');
    spinAnimation();
    slowTimer = window.setTimeout(() => { if (busy) status.textContent = offer ? 'Updating your bag…' : 'Preparing your reward…'; }, 8000);
    try {
      await services();
      let session = await window.TMPrivateOffers.ensureSession({ refresh: retry });
      if (!session) throw new Error('session_unavailable');
      if (session.state === 'expired') { renderExpired(); return; }
      if (session.state !== 'claimed') session = await window.TMPrivateOffers.claim();
      const awarded = sessionOffer(session);
      if (!awarded) throw new Error('claim_unavailable');
      if (offerExpired(awarded)) { renderExpired(); return; }
      offer = awarded;
      const apply = autoApply(offer);
      if (!reactivating) await landAnimation(Number(offer.angle));
      else paintAngle(Number(offer.angle));
      revealing = false;
      busy = applying;
      renderResult();
      await apply;
    } catch {
      stopAnimation();
      status.textContent = 'Please try spinning again.';
      phase = 'error';
    } finally {
      revealing = false;
      busy = applying;
      window.clearTimeout(slowTimer);
      stopAnimation();
      if (offer && !expired) { paintAngle(Number(offer.angle)); renderResult(); }
      else if (expired) renderExpired();
      else setPhase(phase === 'error' ? 'error' : 'idle');
    }
  };
  const automaticOpenEligible = reason => root.dataset.tmProductPage === 'true' && !onCartPage() && !window.Shopify?.designMode && !document.hidden && overlay.hidden
    && !busy && canShowAutomatically(reason) && !cartBlocked() && !otherDialogOpen()
    && window.TMPrivateOffers?.getSession?.()?.state === 'available';
  const showAutomatically = async reason => {
    if (triggerInFlight || window.performance.now() < triggerRetryAt || !automaticOpenEligible(reason)) return;
    triggerInFlight = true;
    try {
      await window.TMPrivateOffers?.ensureSession?.({ refresh: true });
      const cart = await getCart();
      if (reason === 'cart-return-no-checkout' && Number(cart.item_count) < 1) {
        cartRecoveryReadyAt = 0;
        return;
      }
      const present = () => {
        if (!automaticOpenEligible(reason)) return;
        root.dataset.triggerReason = reason;
        if (open()) rememberTrigger(reason, Number(cart.item_count) || 0);
      };
      if (window.navigator.locks?.request) await window.navigator.locks.request('tm-wheel-auto-v4', { ifAvailable: true }, lock => { if (lock) present(); });
      else present();
    } catch {
      triggerRetryAt = window.performance.now() + 5000;
    } finally {
      triggerInFlight = false;
    }
  };
  const recordDepth = () => {
    const available = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    const currentY = Math.max(0, window.scrollY);
    maximumDepth = Math.max(maximumDepth, Math.min(1, currentY / available));
    if (maximumDepth >= .25) interestSeen = true;
    if (maximumDepth >= .7 && currentY < previousScrollY) upwardScroll += previousScrollY - currentY;
    else if (currentY > previousScrollY + 24) upwardScroll = 0;
    previousScrollY = currentY;
    lastInteractionAt = window.performance.now();
  };
  const advanceHesitation = () => {
    tick();
    if (document.hidden) return;
    activeMilliseconds += triggerTickMilliseconds;
    const quietFor = window.performance.now() - lastInteractionAt;
    if (cartRecoveryReadyAt > 0 && window.performance.now() >= cartRecoveryReadyAt && quietFor >= 700) {
      void showAutomatically('cart-return-no-checkout');
      return;
    }
    if (reviewsSeen && activeMilliseconds >= 3500 && quietFor >= 700) {
      void showAutomatically('reviews-section');
      return;
    }
    if (maximumDepth >= .88 && activeMilliseconds >= 5000 && quietFor >= 700) {
      void showAutomatically('deep-scroll');
      return;
    }
    if (maximumDepth >= .7 && upwardScroll >= 140 && activeMilliseconds >= 5000 && quietFor >= 700) {
      void showAutomatically('scroll-backtrack');
      return;
    }
    if (interestSeen && activeMilliseconds >= 5000 && quietFor >= 800) { void showAutomatically('product-interest'); return; }
    if (activeMilliseconds >= 8000 && quietFor >= 1200) void showAutomatically('time-on-page');
  };
  productForms().forEach(form => {
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      if (entries.some(item => item.isIntersecting)) {
        interestSeen = true;
        observer.disconnect();
      }
    }, { threshold: .2 });
    observer.observe(form);
  });
  if ('IntersectionObserver' in window) {
    const reviewTarget = document.querySelector('[data-tm-deferred-reviews], #judgeme_product_reviews, .tm-ember-nightfall__review-widget, .tm-violet-nightfall__review-widget, .tm-pdp-reviews__shell');
    if (reviewTarget) {
      const reviewObserver = new IntersectionObserver(entries => {
        if (!entries.some(item => item.isIntersecting)) return;
        reviewsSeen = true;
        interestSeen = true;
        reviewObserver.disconnect();
      }, { rootMargin: '0px 0px -15% 0px', threshold: .08 });
      reviewObserver.observe(reviewTarget);
    }
  }
  document.addEventListener('scroll', recordDepth, { passive: true });
  document.addEventListener('pointerdown', () => { lastInteractionAt = window.performance.now(); }, { passive: true });
  document.addEventListener('keydown', () => { lastInteractionAt = window.performance.now(); }, { passive: true });
  if (finePointer) document.addEventListener('mouseout', event => {
    if (!event.relatedTarget && event.clientY <= 8 && activeMilliseconds >= 10000 && interestSeen) void showAutomatically('exit-intent');
  });
  recordDepth();
  document.addEventListener('tm:wheel-manual-open', async event => {
    if (busy || !overlay.hidden) return;
    try {
      await services();
      await window.TMPrivateOffers.ensureSession({ refresh: true });
      document.querySelector('cart-notification')?.close?.();
      document.querySelector('cart-drawer.active')?.close?.();
      root.dataset.triggerReason = event.detail?.source || 'manual';
      if (open()) window.TMWheelJourney?.markManual(root.dataset.triggerReason);
    } catch { window.TMWheelJourney?.track('tm_wheel_open_failed', { source: event.detail?.source || 'manual' }); }
  });
  one('checkout').addEventListener('click', () => {
    window.TMWheelJourney?.track('tm_wheel_checkout_click', { rewardKind: offer?.kind || null, applied: Boolean(outcome?.applied) });
  });
  button.addEventListener('click', reveal);
  addProductButton?.addEventListener('click', () => { void addSelectedProduct(); });
  one('apply').addEventListener('click', () => {
    if (busy || !offer || offerExpired(offer) || cartBlocked()) return;
    void autoApply(offer);
  });
  root.querySelectorAll('[data-tm-v2-close]').forEach(control => control.addEventListener('click', () => close(true, control.classList.contains('tm-private-wheel__secondary') ? 'maybe-later' : 'close-button')));
  overlay.addEventListener('click', event => { if (event.target === overlay) close(true, 'overlay'); });
  one('cart').addEventListener('click', () => { window.TMWheelVisit?.markCart?.(); close(false); });
  document.addEventListener('keydown', event => {
    if (overlay.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); close(true, 'escape'); return; }
    if (event.key !== 'Tab') return;
    const controls = [...dialog.querySelectorAll('button:not(:disabled), a[href], [tabindex="0"]')].filter(node => !node.closest('[hidden]') && node.getClientRects().length);
    if (!controls.length) { event.preventDefault(); dialog.focus(); return; }
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || document.activeElement === dialog)) { event.preventDefault(); first.focus(); }
  });
  document.addEventListener('tm:wheel-cart-entered', () => {
    close(false, 'cart-state');
    cartRecoveryReadyAt = 0;
  });
  document.addEventListener('tm:wheel-checkout-started', () => { cartRecoveryReadyAt = 0; });
  document.addEventListener('tm:wheel-return-with-cart', queueCartRecovery);
  document.addEventListener('tm:cart-add-confirmed', () => {
    window.TMWheelVisit?.markCart?.();
  });
  document.addEventListener('tm:private-offer-session', event => {
    if (busy || event.detail?.ready !== true) return;
    const session = event.detail.session;
    if (session?.state === 'expired') { renderExpired(); return; }
    if (phase !== 'error') return;
    status.textContent = '';
    const recoveredOffer = sessionOffer(session);
    if (recoveredOffer) { offer = recoveredOffer; paintAngle(Number(offer.angle)); renderResult(); if (!offerExpired(offer)) void autoApply(offer); }
    else if (session?.state === 'available') setPhase('idle');
  });
  const observedCartNodes = new WeakSet();
  const cartVisibilityObserver = new MutationObserver(() => {
    if (cartBlocked()) close(false);
    observeCartVisibility();
  });
  const observeCartVisibility = () => {
    [document.body, ...document.querySelectorAll('cart-drawer, #cart-notification')].forEach(node => {
      if (!node || observedCartNodes.has(node)) return;
      cartVisibilityObserver.observe(node, { attributes: true, attributeFilter: ['class', 'hidden', 'aria-hidden'] });
      observedCartNodes.add(node);
    });
  };
  const syncCartVisibility = () => {
    observeCartVisibility();
    const blocked = cartBlocked();
    if (blocked) close(false, 'cart-state');
    else if (cartWasBlocked && cartReturnEligible()) queueCartRecovery();
    cartWasBlocked = blocked;
  };
  ['cart:open', 'cart:opened', 'cart:close', 'cart:closed'].forEach(name => document.addEventListener(name, syncCartVisibility));
  window.addEventListener('pageshow', () => { syncCartVisibility(); if (cartReturnEligible()) queueCartRecovery(); recordDepth(); tick(); });
  window.addEventListener('popstate', syncCartVisibility);
  document.addEventListener('DOMContentLoaded', observeCartVisibility, { once: true });
  observeCartVisibility();
  cartWasBlocked = cartBlocked();
  if (cartReturnEligible()) queueCartRecovery();
  document.addEventListener('visibilitychange', () => { if (document.hidden) stopAnimation(); else if (revealing && !overlay.hidden) spinAnimation(); tick(); });
  triggerTimer = window.setInterval(advanceHesitation, triggerTickMilliseconds);
})();
